import { useContext } from 'react';
import { ApolloError, gql } from '@apollo/client';
import { AppContext } from '../providers/AppProvider';
import { GetCategoriesProfilesWithBoardsQuery, useGetCategoriesProfilesWithBoardsQuery } from '../models/graphql';
import { PostEditorContextEnum } from '../models/post-editor';
import { triggerErrorToast } from '../helpers/triggerErrorToast';
import { useClosePostEditor } from './useClosePostEditor';

export type CategoriesProfilesWithBoardsResult = {
  loading: boolean;
  error: ApolloError | undefined;
  postEditorCategoriesProfiles: GetCategoriesProfilesWithBoardsQuery | undefined;
};

gql`
  query GetCategoriesProfilesWithBoards($workspaceId: ID!) {
    workspace(workspaceId: $workspaceId) {
      id
      categories(statusFilter: ACTIVE) {
        ...CategoryFields
      }
      socialProfiles {
        ...SocialProfileFields
      }
    }
  }
`;

export type SocialProfileWithBoards = GetCategoriesProfilesWithBoardsQuery['workspace']['socialProfiles'][number];

export const useCategoriesProfilesWithBoards = (): CategoriesProfilesWithBoardsResult => {
  const { selectedWorkspaceId, postEditorContext } = useContext(AppContext);
  const { closePostEditor } = useClosePostEditor();
  const onClosePostEditor =
    postEditorContext.type !== PostEditorContextEnum.undefined ? postEditorContext.onClose : undefined;

  const {
    error,
    loading,
    data: postEditorCategoriesProfiles
  } = useGetCategoriesProfilesWithBoardsQuery({
    variables: { workspaceId: selectedWorkspaceId }
  });

  if (error) {
    //we set context in order to close post editor (modal)
    onClosePostEditor && onClosePostEditor(false);
    closePostEditor();
    triggerErrorToast('Error Fetching Workspace Data')(error);
  }

  return {
    loading,
    error,
    postEditorCategoriesProfiles
  };
};
